var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQsg22({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 184,
    viewBox: "0 0 278 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13793_104689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 184,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13793_104689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 184,
    fill: "url(#paint0_radial_13793_104689)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 184,
    fill: "url(#paint1_linear_13793_104689)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.988 32.2746C211.65 44.931 153.18 126.643 34.7784 170.159C28.0849 172.619 29.7729 185.079 36.9042 185.079H415.266C418.469 185.079 420.918 182.658 420.917 179.455C420.905 149.647 414.166 12.2122 289.988 32.2746Z",
    fill: "url(#paint2_radial_13793_104689)",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.988 32.2746C211.65 44.931 153.18 126.643 34.7784 170.159C28.0849 172.619 29.7729 185.079 36.9042 185.079H415.266C418.469 185.079 420.918 182.658 420.917 179.455C420.905 149.647 414.166 12.2122 289.988 32.2746Z",
    fill: "url(#paint3_linear_13793_104689)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.534,
    cy: 41.6215,
    r: 51.3461,
    fill: "#FFD3B3",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.478 176.414H401.489C329.232 168.29 297.157 145.722 274.919 130.075C257.07 117.516 245.558 109.416 224.692 116.821L158.478 176.414Z",
    fill: "url(#paint4_linear_13793_104689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.211 179.202V179.995C440.284 179.642 440.338 179.374 439.211 179.202Z",
    fill: "url(#paint5_linear_13793_104689)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.834 79.9891C207.744 89.4613 234.104 76.7367 238.116 78.1006L161.214 120.562C161.214 120.562 140.089 137.51 130.631 128.996C121.173 120.482 152.977 81.3395 101.173 -5.08048C91.8823 -20.58 171.925 70.5169 189.834 79.9891Z",
    fill: "url(#paint6_linear_13793_104689)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4487 109.244C-15.6117 119.054 -21.3002 149.156 -26.7562 151.799L-27.5532 26.5976C-19.315 61.1869 69.809 20.3424 79.3604 72.8472C83.878 97.6814 42.5091 99.4332 13.4487 109.244Z",
    fill: "url(#paint7_linear_13793_104689)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9812 86.8186C182.425 86.8186 254.124 70.2101 254.124 49.7225C254.124 49.415 254.108 49.1084 254.075 48.8027H33.9277V84.1221C52.4729 85.861 72.7443 86.8186 93.9812 86.8186Z",
    fill: "#FFFEF9",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_13793_104689)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 77.5,
    r: 46.5,
    fill: "white",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.182 157.035V114.403C185.182 112.33 186.861 110.65 188.934 110.65H244.248C246.321 110.65 248 112.33 248 114.403V156.999C248 159.072 246.321 160.751 244.248 160.751H188.934C186.861 160.751 185.217 159.108 185.182 157.035Z",
    fill: "#C7DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.076 149.138V117.405C188.076 115.332 189.755 113.652 191.828 113.652H241.354C243.426 113.652 245.106 115.332 245.106 117.405V149.102C245.106 151.175 243.426 152.854 241.354 152.854H191.828C189.755 152.854 188.076 151.175 188.076 149.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.027 128.498C216.99 126.662 215.652 124.843 214.009 122.688C212.251 120.381 209.489 119.689 207.229 120.019C204.863 120.364 202.209 121.796 200.613 124.92C199.03 128.015 197.996 133.119 199.745 136.611C200.527 138.172 198.322 139.055 198.322 139.055C198.322 139.055 200.587 141.634 209.023 140.7C212.603 140.303 214.325 139.632 216.398 138.008C219.924 135.247 219.886 131.792 218.027 128.498Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.861 136.346C234.897 136.168 234.666 135.346 234.569 134.911C234.391 134.113 233.242 131.923 233.242 131.923L233.42 131.637C233.42 131.637 234.349 131.494 234.457 131.279C234.564 131.065 234.385 130.779 234.171 130.708L232.42 130.029C232.42 129.993 232.384 129.993 232.348 130.029L230.669 131.387C230.598 131.458 230.562 131.565 230.598 131.673L232.631 136.607L234.861 136.346Z",
    fill: "#BF8F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.384 140.956C205.116 140.808 212.688 140.038 213.628 140.208C215.256 140.502 219.596 139.916 223.548 143.42C225.406 145.814 226.118 149.443 229.548 148.442C234.045 146.73 233.631 139.523 232.632 136.608L234.827 136.224C234.827 136.224 241.869 143.984 236.191 152.854H192.901C195.47 146.535 198.821 141.776 204.384 140.956Z",
    fill: "#F05EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.241 146.346C208.943 146.346 205.07 140.859 205.07 140.859C205.07 140.859 206.291 140.588 206.608 139.923C207.088 138.917 206.867 136.615 206.265 134.981C206.015 134.266 205.727 134.093 205.727 134.093C205.727 134.093 208.979 132.806 210.623 132.163C210.909 133.152 211.018 137.043 212.292 139.077C212.905 140.056 214.458 140.29 214.458 140.29C214.458 140.29 213.242 146.346 211.241 146.346Z",
    fill: "url(#paint8_radial_13793_104689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.268 129.48L213.702 126.583C213.202 123.899 210.752 121.916 208.322 122.483L207.534 122.611C203.966 123.139 202.655 126.191 203.298 129.367L203.691 131.332C204.334 134.583 207.507 137.035 210.704 136.357C213.443 135.775 214.876 132.391 214.268 129.48Z",
    fill: "#BF8F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.065 127.802L210.137 132.698L213.139 132.233L211.995 126.766L209.065 127.802Z",
    fill: "url(#paint9_radial_13793_104689)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.763 132.842L204.156 132.949C203.155 133.092 202.19 132.449 202.047 131.448C201.904 130.448 202.548 129.519 203.548 129.34L204.763 132.842Z",
    fill: "#BF8F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.572 128.974C211.825 128.934 211.97 128.521 211.896 128.053C211.821 127.585 211.555 127.238 211.302 127.278C211.049 127.319 210.904 127.731 210.978 128.199C211.053 128.668 211.319 129.014 211.572 128.974Z",
    fill: "#3A312E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.886 129.873C207.14 129.832 207.285 129.42 207.21 128.952C207.135 128.483 206.87 128.137 206.616 128.177C206.363 128.217 206.218 128.63 206.292 129.098C206.367 129.566 206.633 129.913 206.886 129.873Z",
    fill: "#3A312E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.125 128.144C209.125 128.144 209.34 129.107 209.77 129.245C210.233 129.394 210.505 129.513 210.674 129.937C210.84 130.355 210.594 130.859 210.236 131.155C209.843 131.405 209.94 131.86 209.94 131.86C209.94 131.86 208.618 131.038 208.439 130.609C207.974 129.466 209.125 128.144 209.125 128.144Z",
    fill: "#BF8F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.54 132.799C208.362 132.835 208.254 133.013 208.326 133.192C208.576 133.835 209.219 134.228 209.934 134.121C210.648 134.014 211.149 133.442 211.22 132.763C211.256 132.584 211.077 132.441 210.899 132.477L208.54 132.799Z",
    fill: "#602219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.102 132.519C211.043 132.483 210.973 132.462 210.899 132.476L208.54 132.798C208.437 132.819 208.363 132.889 208.329 132.978C208.65 133.12 209.078 133.191 209.541 133.155C210.217 133.084 210.849 132.838 211.102 132.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.964 159.357C247.964 160.394 247.142 161.216 246.106 161.216H183.037C180.286 161.108 180 157.678 180 157.678H247.964V159.357Z",
    fill: "#8EBAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.595 118.594L226.31 118.236L236.994 137.533L235.743 138.177L225.595 118.594Z",
    fill: "#BDBDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.171 134.531L233.243 134.674L232.921 133.388L232.993 131.279C233.028 131.029 232.993 130.815 232.85 130.6C232.85 130.6 232.707 130.386 232.564 130.6C232.421 130.815 232.063 133.03 232.063 133.03L232.171 134.531Z",
    fill: "#BF8F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.407 122.593C210.407 122.593 207.3 121.705 206.44 125.048C206.274 125.691 205.831 132.184 201.117 132.424C200.942 132.424 200.341 132.342 200.441 132.184C200.542 132.026 201.722 124.958 203.393 123.265C205.064 121.572 207.577 120.635 210.407 122.593Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_13793_104689)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.015,
    y: 96,
    width: 25.5303,
    height: 25.5303,
    rx: 12.7651,
    fill: "#0078D4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_13793_104689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.337 106.168C233.337 105.075 232.382 104.188 231.203 104.188H226.081C224.902 104.188 223.947 105.075 223.947 106.168V111.711C223.947 112.804 224.902 113.691 226.081 113.691H231.203C232.382 113.691 233.337 112.804 233.337 111.711V106.168ZM235.131 106.573C234.538 107.032 234.191 107.74 234.191 108.49V109.412C234.191 110.154 234.531 110.856 235.115 111.316L236.551 112.449C236.967 112.777 237.606 112.503 237.606 111.996V105.925C237.606 105.421 236.972 105.146 236.555 105.469L235.131 106.573Z",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35 48.2812C33.7891 48.2812 32.6914 48.0742 31.707 47.6602C30.7227 47.2461 29.8828 46.668 29.1875 45.9258C28.4922 45.1758 27.9531 44.2812 27.5703 43.2422C27.1875 42.2031 26.9961 41.0547 26.9961 39.7969C26.9961 38.4531 27.1875 37.2344 27.5703 36.1406C27.9609 35.0469 28.5117 34.1133 29.2227 33.3398C29.9414 32.5664 30.8125 31.9688 31.8359 31.5469C32.8594 31.125 34.0039 30.9141 35.2695 30.9141C36.4414 30.9141 37.5117 31.1211 38.4805 31.5352C39.4492 31.9492 40.2773 32.5312 40.9648 33.2812C41.6523 34.0234 42.1836 34.9141 42.5586 35.9531C42.9414 36.9922 43.1328 38.1367 43.1328 39.3867C43.1328 41.043 42.8555 42.4961 42.3008 43.7461C41.7461 44.9883 40.9648 45.9883 39.957 46.7461L44.832 50.2617H40.5898L37.5898 47.9297C37.1914 48.0391 36.7773 48.125 36.3477 48.1875C35.918 48.25 35.4688 48.2812 35 48.2812ZM35.1289 33.3633C34.3633 33.3633 33.6602 33.5156 33.0195 33.8203C32.3867 34.1172 31.8398 34.543 31.3789 35.0977C30.918 35.6445 30.5586 36.3008 30.3008 37.0664C30.0508 37.832 29.9258 38.6836 29.9258 39.6211C29.9258 40.5508 30.0469 41.3984 30.2891 42.1641C30.5391 42.9297 30.8867 43.5859 31.332 44.1328C31.7773 44.6719 32.3125 45.0938 32.9375 45.3984C33.5625 45.6953 34.2539 45.8438 35.0117 45.8438C35.8164 45.8438 36.5391 45.7031 37.1797 45.4219C37.8203 45.1406 38.3633 44.7383 38.8086 44.2148C39.2617 43.6836 39.6094 43.0352 39.8516 42.2695C40.0938 41.5039 40.2148 40.6328 40.2148 39.6562C40.2148 38.6562 40.0977 37.7656 39.8633 36.9844C39.6289 36.2031 39.293 35.5469 38.8555 35.0156C38.418 34.4766 37.8828 34.0664 37.25 33.7852C36.625 33.5039 35.918 33.3633 35.1289 33.3633ZM56.375 48H53.6562V46.1016H53.6094C52.8203 47.5547 51.5938 48.2812 49.9297 48.2812C47.0938 48.2812 45.6758 46.5781 45.6758 43.1719V36H48.3945V42.8906C48.3945 45.0469 49.2266 46.125 50.8906 46.125C51.6953 46.125 52.3555 45.8281 52.8711 45.2344C53.3945 44.6406 53.6562 43.8633 53.6562 42.9023V36H56.375V48ZM61.2969 33.4805C60.8516 33.4805 60.4688 33.3359 60.1484 33.0469C59.8359 32.7578 59.6797 32.3906 59.6797 31.9453C59.6797 31.5 59.8359 31.1289 60.1484 30.832C60.4688 30.5352 60.8516 30.3867 61.2969 30.3867C61.7578 30.3867 62.1484 30.5352 62.4688 30.832C62.7891 31.1289 62.9492 31.5 62.9492 31.9453C62.9492 32.3672 62.7891 32.7305 62.4688 33.0352C62.1484 33.332 61.7578 33.4805 61.2969 33.4805ZM62.6445 48H59.9258V36H62.6445V48ZM74.7969 47.4492C73.8359 48.0039 72.6992 48.2812 71.3867 48.2812C69.6055 48.2812 68.168 47.7266 67.0742 46.6172C65.9805 45.5 65.4336 44.0547 65.4336 42.2812C65.4336 40.3047 66.0195 38.7188 67.1914 37.5234C68.3711 36.3203 69.9453 35.7188 71.9141 35.7188C73.0078 35.7188 73.9727 35.9102 74.8086 36.293V38.8242C73.9727 38.1992 73.082 37.8867 72.1367 37.8867C70.9883 37.8867 70.0469 38.2773 69.3125 39.0586C68.5781 39.832 68.2109 40.8477 68.2109 42.1055C68.2109 43.3477 68.5547 44.3281 69.2422 45.0469C69.9375 45.7656 70.8672 46.125 72.0312 46.125C73.0078 46.125 73.9297 45.7773 74.7969 45.082V47.4492ZM88.3906 48H84.9453L80.2812 42.2344H80.2344V48H77.5039V30.2344H80.2344V41.4961H80.2812L84.6875 36H87.957L83 41.7891L88.3906 48ZM96.2539 47.332V44.4609C96.5117 44.6953 96.8164 44.9062 97.168 45.0938C97.5273 45.2812 97.9062 45.4414 98.3047 45.5742C98.7031 45.6992 99.1016 45.7969 99.5 45.8672C99.8984 45.9375 100.266 45.9727 100.602 45.9727C101.773 45.9727 102.645 45.7773 103.215 45.3867C103.793 44.9961 104.082 44.4297 104.082 43.6875C104.082 43.2891 103.984 42.9453 103.789 42.6562C103.602 42.3594 103.336 42.0898 102.992 41.8477C102.648 41.6055 102.242 41.375 101.773 41.1562C101.312 40.9297 100.816 40.6953 100.285 40.4531C99.7148 40.1484 99.1836 39.8398 98.6914 39.5273C98.1992 39.2148 97.7695 38.8711 97.4023 38.4961C97.043 38.1133 96.7578 37.6836 96.5469 37.207C96.3438 36.7305 96.2422 36.1719 96.2422 35.5312C96.2422 34.7422 96.418 34.0586 96.7695 33.4805C97.1289 32.8945 97.5977 32.4141 98.1758 32.0391C98.7617 31.6562 99.4258 31.375 100.168 31.1953C100.91 31.0078 101.668 30.9141 102.441 30.9141C104.199 30.9141 105.48 31.1133 106.285 31.5117V34.2656C105.332 33.5781 104.105 33.2344 102.605 33.2344C102.191 33.2344 101.777 33.2734 101.363 33.3516C100.957 33.4297 100.59 33.5586 100.262 33.7383C99.9414 33.918 99.6797 34.1484 99.4766 34.4297C99.2734 34.7109 99.1719 35.0508 99.1719 35.4492C99.1719 35.8242 99.25 36.1484 99.4062 36.4219C99.5625 36.6953 99.7891 36.9453 100.086 37.1719C100.391 37.3984 100.758 37.6211 101.188 37.8398C101.625 38.0508 102.129 38.2812 102.699 38.5312C103.285 38.8359 103.836 39.1562 104.352 39.4922C104.875 39.8281 105.332 40.1992 105.723 40.6055C106.121 41.0117 106.434 41.4648 106.66 41.9648C106.895 42.457 107.012 43.0195 107.012 43.6523C107.012 44.5039 106.84 45.2227 106.496 45.8086C106.152 46.3945 105.688 46.8711 105.102 47.2383C104.523 47.6055 103.855 47.8711 103.098 48.0352C102.34 48.1992 101.539 48.2812 100.695 48.2812C100.414 48.2812 100.066 48.2578 99.6523 48.2109C99.2461 48.1719 98.8281 48.1094 98.3984 48.0234C97.9688 47.9453 97.5625 47.8477 97.1797 47.7305C96.7969 47.6133 96.4883 47.4805 96.2539 47.332ZM115.426 47.8711C114.895 48.1367 114.195 48.2695 113.328 48.2695C111 48.2695 109.836 47.1523 109.836 44.918V38.1328H107.832V36H109.836V33.2227L112.555 32.4492V36H115.426V38.1328H112.555V44.1328C112.555 44.8438 112.684 45.3516 112.941 45.6562C113.199 45.9609 113.629 46.1133 114.23 46.1133C114.691 46.1133 115.09 45.9805 115.426 45.7148V47.8711ZM126.98 48H124.344V46.125H124.297C123.469 47.5625 122.254 48.2812 120.652 48.2812C119.473 48.2812 118.547 47.9609 117.875 47.3203C117.211 46.6797 116.879 45.832 116.879 44.7773C116.879 42.5117 118.184 41.1914 120.793 40.8164L124.355 40.3125C124.355 38.6016 123.543 37.7461 121.918 37.7461C120.488 37.7461 119.199 38.2383 118.051 39.2227V36.8438C119.316 36.0938 120.777 35.7188 122.434 35.7188C125.465 35.7188 126.98 37.2109 126.98 40.1953V48ZM124.355 42.1055L121.836 42.457C121.055 42.5586 120.465 42.75 120.066 43.0312C119.676 43.3047 119.48 43.7891 119.48 44.4844C119.48 44.9922 119.66 45.4102 120.02 45.7383C120.387 46.0586 120.875 46.2188 121.484 46.2188C122.312 46.2188 122.996 45.9297 123.535 45.3516C124.082 44.7656 124.355 44.0312 124.355 43.1484V42.1055ZM137.27 38.5898C136.941 38.332 136.469 38.2031 135.852 38.2031C135.047 38.2031 134.375 38.5664 133.836 39.293C133.297 40.0195 133.027 41.0078 133.027 42.2578V48H130.309V36H133.027V38.4727H133.074C133.34 37.6289 133.746 36.9727 134.293 36.5039C134.848 36.0273 135.465 35.7891 136.145 35.7891C136.637 35.7891 137.012 35.8633 137.27 36.0117V38.5898ZM146.223 47.8711C145.691 48.1367 144.992 48.2695 144.125 48.2695C141.797 48.2695 140.633 47.1523 140.633 44.918V38.1328H138.629V36H140.633V33.2227L143.352 32.4492V36H146.223V38.1328H143.352V44.1328C143.352 44.8438 143.48 45.3516 143.738 45.6562C143.996 45.9609 144.426 46.1133 145.027 46.1133C145.488 46.1133 145.887 45.9805 146.223 45.7148V47.8711ZM41.1875 78.8516C39.4375 79.8047 37.4883 80.2812 35.3398 80.2812C32.8555 80.2812 30.8438 79.5078 29.3047 77.9609C27.7656 76.4141 26.9961 74.3672 26.9961 71.8203C26.9961 69.2188 27.8359 67.0859 29.5156 65.4219C31.2031 63.75 33.3438 62.9141 35.9375 62.9141C37.8047 62.9141 39.375 63.1875 40.6484 63.7344V66.6055C39.3594 65.7461 37.8242 65.3164 36.043 65.3164C34.2539 65.3164 32.7852 65.9062 31.6367 67.0859C30.4961 68.2656 29.9258 69.793 29.9258 71.668C29.9258 73.5977 30.418 75.1172 31.4023 76.2266C32.3867 77.3281 33.7227 77.8789 35.4102 77.8789C36.5664 77.8789 37.5664 77.6562 38.4102 77.2109V73.2148H34.8711V70.8711H41.1875V78.8516ZM54.9688 80H52.25V78.1016H52.2031C51.4141 79.5547 50.1875 80.2812 48.5234 80.2812C45.6875 80.2812 44.2695 78.5781 44.2695 75.1719V68H46.9883V74.8906C46.9883 77.0469 47.8203 78.125 49.4844 78.125C50.2891 78.125 50.9492 77.8281 51.4648 77.2344C51.9883 76.6406 52.25 75.8633 52.25 74.9023V68H54.9688V80ZM59.8906 65.4805C59.4453 65.4805 59.0625 65.3359 58.7422 65.0469C58.4297 64.7578 58.2734 64.3906 58.2734 63.9453C58.2734 63.5 58.4297 63.1289 58.7422 62.832C59.0625 62.5352 59.4453 62.3867 59.8906 62.3867C60.3516 62.3867 60.7422 62.5352 61.0625 62.832C61.3828 63.1289 61.543 63.5 61.543 63.9453C61.543 64.3672 61.3828 64.7305 61.0625 65.0352C60.7422 65.332 60.3516 65.4805 59.8906 65.4805ZM61.2383 80H58.5195V68H61.2383V80ZM75.7109 80H72.9922V77.9609H72.9453C72.0703 79.5078 70.7227 80.2812 68.9023 80.2812C67.4258 80.2812 66.2422 79.7461 65.3516 78.6758C64.4688 77.5977 64.0273 76.1328 64.0273 74.2812C64.0273 72.2969 64.5156 70.707 65.4922 69.5117C66.4766 68.3164 67.7852 67.7188 69.418 67.7188C71.0352 67.7188 72.2109 68.3672 72.9453 69.6641H72.9922V62.2344H75.7109V80ZM73.0273 74.5156V72.9453C73.0273 72.0938 72.75 71.3711 72.1953 70.7773C71.6406 70.1836 70.9336 69.8867 70.0742 69.8867C69.0586 69.8867 68.2578 70.2656 67.6719 71.0234C67.0938 71.7812 66.8047 72.832 66.8047 74.1758C66.8047 75.3945 67.082 76.3594 67.6367 77.0703C68.1992 77.7734 68.9531 78.125 69.8984 78.125C70.8281 78.125 71.582 77.7852 72.1602 77.1055C72.7383 76.418 73.0273 75.5547 73.0273 74.5156ZM89.4219 74.7383H81.2422C81.2734 75.8477 81.6133 76.7031 82.2617 77.3047C82.918 77.9062 83.8164 78.207 84.957 78.207C86.2383 78.207 87.4141 77.8242 88.4844 77.0586V79.25C87.3906 79.9375 85.9453 80.2812 84.1484 80.2812C82.3828 80.2812 80.9961 79.7383 79.9883 78.6523C78.9883 77.5586 78.4883 76.0234 78.4883 74.0469C78.4883 72.1797 79.0391 70.6602 80.1406 69.4883C81.25 68.3086 82.625 67.7188 84.2656 67.7188C85.9062 67.7188 87.1758 68.2461 88.0742 69.3008C88.9727 70.3555 89.4219 71.8203 89.4219 73.6953V74.7383ZM86.7969 72.8164C86.7891 71.8398 86.5586 71.082 86.1055 70.543C85.6523 69.9961 85.0273 69.7227 84.2305 69.7227C83.4492 69.7227 82.7852 70.0078 82.2383 70.5781C81.6992 71.1484 81.3672 71.8945 81.2422 72.8164H86.7969Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13793_104689",
    x: -29.4407,
    y: -29.7168,
    width: 510.358,
    height: 274.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_13793_104689",
    x: 83.188,
    y: -89.7246,
    width: 262.692,
    height: 262.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_13793_104689",
    x: 128.478,
    y: 83.9951,
    width: 341.558,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_13793_104689",
    x: 60.4258,
    y: -46.8516,
    width: 217.691,
    height: 218.239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_13793_104689",
    x: -77.5532,
    y: -23.4023,
    width: 207.254,
    height: 225.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_13793_104689",
    x: -16.0723,
    y: -1.19727,
    width: 320.196,
    height: 138.016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_13793_104689",
    x: 27,
    y: -29,
    width: 213,
    height: 213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_13793_104689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_13793_104689",
    x: 213.642,
    y: 92.2828,
    width: 34.2766,
    height: 34.2766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.655973
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18658
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13793_104689"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.218658
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.546644
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13793_104689",
    result: "effect2_dropShadow_13793_104689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13793_104689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_13793_104689",
    x: 222.734,
    y: 103.218,
    width: 16.0852,
    height: 11.9277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.242573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.606433
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13793_104689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13793_104689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13793_104689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(33.4994) scale(333.377 1774.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204351,
    stopColor: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510854,
    stopColor: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13793_104689",
    x1: 139,
    y1: 0,
    x2: 139,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_13793_104689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-15.1262 30.2832) rotate(19.5449) scale(462.704 1686.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204351,
    stopColor: "#6993FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510854,
    stopColor: "#CBC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13793_104689",
    x1: 202.895,
    y1: 30.2832,
    x2: 202.895,
    y2: 185.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13793_104689",
    x1: 224.495,
    y1: 119.777,
    x2: 224.495,
    y2: 174.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C9FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13793_104689",
    x1: 224.495,
    y1: 119.777,
    x2: 224.495,
    y2: 174.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C9FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13793_104689",
    x1: 115.107,
    y1: 51.5469,
    x2: 147.923,
    y2: 121.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#875EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13793_104689",
    x1: 1.57566,
    y1: 46.1996,
    x2: 0.260626,
    y2: 60.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0FFAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1DAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13793_104689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.933 134.968) rotate(180) scale(3.69281 3.69306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B643D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615563,
    stopColor: "#B4825B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8F68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_13793_104689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.351 130.403) rotate(-12.2108) scale(2.38557 2.26855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#591C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348309,
    stopColor: "#733B27",
    stopOpacity: 0.651586
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765739,
    stopColor: "#8E5937",
    stopOpacity: 0.234031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#98653D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13793_104689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 184,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13793_104689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 184,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsg22);
export default __webpack_public_path__ + "static/media/QSG22.024b28d7ba1b0da719eed249697d5fbf.svg";
export { ForwardRef as ReactComponent };